import { render, staticRenderFns } from "./finnisRiskShow.vue?vue&type=template&id=15c25a4a"
import script from "./finnisRiskShow.vue?vue&type=script&lang=js"
export * from "./finnisRiskShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports